<template>
  <vx-card>
    <section class="mb-base">
      <span class="text-black text-2xl">Wilayah</span>
    </section>
    <section>
      <vs-tabs>
        <vs-tab label="Provinsi">
          <div class="tab-text">
            <provinsi-content />
          </div>
        </vs-tab>
        <vs-tab label="Kabupaten/Kota">
          <div class="tab-text">
            <kab-kot-content />
          </div>
        </vs-tab>
        <vs-tab label="Kecamatan">
          <div class="tab-text">
            <kecamatan-content />
          </div>
        </vs-tab>
      </vs-tabs>
    </section>
  </vx-card>
</template>

<script>
import ProvinsiContent from "@/views/wilayah/content/ProvinsiContent.vue";
import KabKotContent from "@/views/wilayah/content/KabKotContent.vue";
import KecamatanContent from "@/views/wilayah/content/KecamatanContent.vue";

export default {
  components: {
    ProvinsiContent,
    KabKotContent,
    KecamatanContent,
  },
  mounted() {
    console.log("Mainmain");
  },
};
</script>
